module.exports = __webpack_public_path__ + "img/trigger.8294788c.svg";